import { render, staticRenderFns } from "./dataRequest.vue?vue&type=template&id=23db480c&scoped=true"
import script from "./dataRequest.vue?vue&type=script&lang=js"
export * from "./dataRequest.vue?vue&type=script&lang=js"
import style0 from "./dataRequest.vue?vue&type=style&index=0&id=23db480c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db480c",
  null
  
)

export default component.exports